import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/educationSafety/img/1.avif';
import image2 from '@src/assets/images/solution/educationSafety/img/2.avif';
import image3 from '@src/assets/images/solution/educationSafety/img/3.avif';
import image4 from '@src/assets/images/solution/educationSafety/img/4.avif';

import customer1 from '@src/assets/images/solution/publicFire/img/customer1.avif';
import function1 from '@src/assets/images/solution/educationSafety/img/function1.avif';
import function2 from '@src/assets/images/solution/educationSafety/img/function2.avif';
import function3 from '@src/assets/images/solution/educationSafety/img/function3.avif';
import function4 from '@src/assets/images/solution/educationSafety/img/function4.avif';
import { educationSafety1, recommendationEdge, recommendationSwitch } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: 'スクールソリューション',

  banner: {
    title: 'AI映像解析で、学校の安全をスマートに守る',
    desc: 'AIが既存のCCTV映像を使って、校内の異常行動や危険兆候を検知。個人情報も安全に保護します。',
  },

  recommend: {
    title: '',
    desc: 'ORBRO OSはリアルタイム位置追跡とスマートモニタリング向けの強力なプラットフォームです。<br/>BLE、UWB、AI映像解析技術を完全統合し、安全性、効率性、拡張性を実現します。',
    labels: {
      desktop: [
        { img: educationSafety1, data: recommendation.ipCamera },
        { img: recommendationEdge, data: recommendation.edgeRtls },
        { img: recommendationSwitch, data: recommendation.switch },
      ],
      mobile: [{ data: recommendation.ipCamera }, { data: recommendation.edgeAi }, { data: recommendation.switch }],
    },
  },

  summary: {
    title: '危険はリアルタイムで察知、即対応',
    desc: 'AIポーズ認識技術により、校舎廊下・階段・教室・実験室などでの暴力・転倒・意識喪失・突発行動を即時に検知・アラート送出。事故の早期発見と迅速対応を支援します。',
    function: {
      card: [
        {
          image: function1,
          title: '暴力行為（喧嘩）自動検知',
          desc: 'パンチや押し合いなどの姿勢変化を解析し、異常があれば即時管理者に通知。校内暴力の早期阻止に貢献します。',
        },
        {
          image: function2,
          title: '廊下・階段での転倒検知＆アラート',
          desc: '転倒を姿勢の変化から把握し、即座にアラートを発信。迅速な緊急対応が可能です。',
        },
        {
          image: function3,
          title: '長時間横たわり・意識なし状態の検知',
          desc: '転倒後の動きの停止や異常姿勢を検知し、意識の喪失や発作などのリスクを察知して警告します。',
        },
        {
          image: function4,
          title: '異常行動（走行・突発動作）の自動検知',
          desc: '廊下・階段での急な走行や突発的な動きを検知し、衝突リスク発生の前に対処できます。',
        },
      ],
    },
  },

  numOfCard: {
    title: 'AI技術で学校安全管理の運用効率を最大化',
    desc: 'リアルタイム検知によって校内での異常行動や危険兆候に迅速・的確に対応します。',
    card: [
      {
        tag: '98%',
        title: '異常行動検出精度',
        desc: 'AI解析による精度の高い検知で、校内のリスクを即時察知・対応。',
      },
      {
        tag: '95%',
        title: '運用人員削減効果',
        desc: '自動化システムにより、保安担当者の人手を大幅に削減可能。',
      },
      {
        tag: '100%',
        title: '個人情報保護遵守率',
        desc: '常時録画せず、イベント時のみ短時間録画を実施。プライバシー保護を徹底します。',
      },
    ],
  },

  func: [
    {
      theme: '高度なAI機能で学校内のリスクを正確に検知・対応',
      title: '状況に応じた対応履歴を自動で記録',
      desc: 'AIポーズ推定技術により、激しい動きや異常・攻撃性行動を解析し、即時に危険を検知・管理。',
      sub1: '高精度解析',
      icon1: IconRulerGray,
      sub2: 'リアルタイム状態把握',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '5段階リスクレベルで即アラート',
      desc: 'AIがリスクを5段階で評価し、重要度に応じた通知を即担当者へ送信。迅速かつ効果的な対応が可能です。',
      sub2: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub1: '高速データ連携',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: 'オンプレミスで独立運用可能',
      desc: '校内サーバー上で運用し、外部サービスへの依存を排除。即時対応と継続的改善が可能です。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度解析',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: 'プライバシー重視のイベント録画',
      desc: 'リスクイベント発生時のみ短時間録画。常時保存は行わず、プライバシーを最大限保護します。',
      sub1: '柔軟なゾーン設定',
      icon1: IconZoneGray,
      sub2: '複数ゾーン対応',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  subfunc: {
    title: '機能概要',
    desc: '安全が確保されれば効率も上がり、事故による損失を抑えられます。ORBROは、危険区域や事故のリスクを包括的に管理する最適な機能を備えています。',
    data: [
      {
        icon: IconAnalytics,
        title: 'AIによる危険行動自動検知',
        desc: '強い動作や異常な挙動をリアルタイムで分析し、危険を自動で感知します。',
      },
      {
        icon: IconChartBar,
        title: '5段階リスクアラート',
        desc: 'リスクを5段階に分類し、明確かつ迅速な通知を実現します。',
      },
      {
        icon: IconSearch,
        title: 'イベント起点の映像保存',
        desc: '異常検知時の短い映像のみを保存し、プライバシーを保護します。',
      },
      {
        icon: IconLayers,
        title: '既存CCTVの活用',
        desc: '新たなハードなしで既存カメラとAI解析を連動させます。',
      },
      {
        icon: IconRoute,
        title: 'ゾーン指定対応設置',
        desc: '保育室など特定ゾーンにAI分析を適用することが可能です。',
      },
      {
        icon: IconLayers,
        title: 'オンプレミス運用',
        desc: '校内サーバーによる迅速かつ自律的な運用ができます。',
      },
      {
        icon: IconChartBar,
        title: '運用人員の最小化',
        desc: '自動化された管理により、人的コストを削減します。',
      },
      {
        icon: IconSearch,
        title: '強化されたプライバシー保護',
        desc: '常時録画なし、必要な時のみ録画することで、プライバシーを確実に保護します。',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
